import { Typography, Box } from '@mui/material';
import { FC } from 'react';

import { JobseekerCreateDto } from '@libs/dto';
import { useForm } from '@carcareers/contexts';
import { OTPInput } from '@carcareers/components';

export const VerifyOtpStep: FC = () => {
  const { data } = useForm<JobseekerCreateDto>();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
      <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 600 }}>
        Verify Your Email
      </Typography>
      <Typography variant="body1" align="center" sx={{ mb: 3 }}>
        We've sent a 6-digit code to <strong>{data?.user?.email}</strong>.<br />
        Please enter it below to verify your email address.
      </Typography>
      <OTPInput name="otp" length={6} />
    </Box>
  );
};

export default VerifyOtpStep;
